import React from 'react'
import styles from './LeaveTypes.module.css'

import PropTypes from 'prop-types'

import {
  TextField,
  Button,
  Grid
} from '@material-ui/core'

class LeaveTypesForm extends React.Component {
  render() {
    return (
      <div>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6}>
          <TextField
              autoComplete="off"
              variant="outlined"
              size="small"
              name="name"
              fullWidth="true"
              label="Name"
              onChange={this.props.onchange}
              value={this.props.item.name}
            />
            </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              autoComplete="off"
              variant="outlined"
              size="small"
              type="number"
              name="no_of_days"
              fullWidth="true"
              label="Number of Day"
              onChange={this.props.onchange}
              value={this.props.item.no_of_days}
              id="no_of_days"
            />
            </Grid>
        </Grid>

        <div className={styles.actionButton}>
          <Button variant="outlined"
                  id="leaveType-submit" color="primary"
                  disabled={!this.props.item.name || !this.props.item.no_of_days}
                  onClick={() => this.props.submit()}>Save</Button>
        </div>
      </div>
    )
  }
}

export default LeaveTypesForm

LeaveTypesForm.propTypes = {
  onchange: PropTypes.func,
  item: PropTypes.object,
  submit: PropTypes.func
}
